/* eslint-disable */
import moment from "moment";

export function generatePassword(passwordLength: number) {
  const numberChars = "0123456789";
  const upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerChars = "abcdefghijklmnopqrstuvwxyz";
  const itemsChars = "!@$^&*()_+";
  const allChars = numberChars + upperChars + lowerChars;
  let randPasswordArray = Array(passwordLength);
  randPasswordArray[0] = numberChars;
  randPasswordArray[1] = upperChars;
  randPasswordArray[2] = lowerChars;
  randPasswordArray[3] = itemsChars;
  randPasswordArray = randPasswordArray.fill(allChars, 4);
  return shuffleArray(
    randPasswordArray.map(function (x) {
      return x[Math.floor(Math.random() * x.length)] as string;
    })
  ).join("");
}

export const getDates = (invitationDates?: string[]) => {
  const parsedDates: any[] = [];
  const dates: string[] = invitationDates ?? [];
  dates.forEach((date: string) => {
    const parsedDate = moment(new Date(date)).format("MM/DD/YY");
    parsedDates.push(parsedDate);
  });
  const lastInvite = Array.from(dates).pop();
  let isOlderThan1Week = false;
  if (lastInvite) {
    const today = new Date().getTime();
    const lastInviteDate = new Date(lastInvite).getTime();
    const diff = today - lastInviteDate;
    const week = 86400000 * 7;

    isOlderThan1Week = diff > week;
  }
  const lastInviteOlderThat1Week = isOlderThan1Week;
  return { parsedDates, lastInviteOlderThat1Week };
};
function shuffleArray(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

export const getDatesByMonthAndYear = (month: number, year: number) => {
  // First day of the given month and year
  const startDate = new Date(year, month, 1);
  // Last day of the given month and year
  // Setting day as 0 goes to the last day of the previous month
  const endDate = new Date(year, month + 1, 0);

  return {
    selectedStartDate: startDate.toISOString(),
    selectedEndDate: endDate.toISOString(),
  };
};
